var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RenderBlock } from '../../render-layout.models';
/** Lotteries "stories" horizontal scroller. Scroller ref + edge-gradient logic are block-local. */
var Stories = /** @class */ (function (_super) {
    __extends(Stories, _super);
    function Stories() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Stories.prototype, "hideStoriesSideGradient", {
        get: function () {
            if (this.storiesScroller) {
                if (this.storiesScroller.offsetWidth + this.storiesScroller.scrollLeft > this.storiesScroller.scrollWidth - 50) {
                    return true;
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    return Stories;
}(RenderBlock));
export { Stories };
